import { isInUIC } from '@Utils/common';
import { CorrelatedTemplateUrl } from 'src/pages/GlobalSetting/CorrelatedRuleTemplates/utils';

export default function getBreadCrumb(t: any, matches: any) {
  const mainRouterNameMap: { [key: string]: string } = {
    '/policy/*': t('side.group.policy'),
    '/administrator/*': t('side.group.administrator'),
  };

  const policySubRouterNameMap: { [key: string]: string } = {
    '/policy/advanced-threat-protection/email': t('side.label.atp'),
    '/policy/data-loss-prevention/email': t('side.label.dlp'),
    '/policy/advanced-threat-protection/collaboration': t('side.label.atp'),
    '/policy/data-loss-prevention/collaboration': t('side.label.dlp'),
    '/policy/global-settings/approved-and-blocked-list': t(
      'policy.globalSettings.userDefined.approvedList'
    ),
    '/policy/global-settings/high-profile-list': t(
      'policy.globalSettings.userDefined.highProfile'
    ),
    '/policy/global-settings/internal-domain-list': t(
      'policy.globalSettings.userDefined.internalDomain'
    ),
    '/policy/global-settings/predictive-machine-learning-exception-list': t(
      'policy.globalSettings.userDefined.machineLearning'
    ),
    '/policy/global-settings/display-name-spoofing-detection-exception-list': t(
      'policy.globalSettings.userDefined.SpoofingDetection'
    ),
    '/policy/global-settings/notification-settings': t(
      'policy.globalSettings.settings.notification'
    ),
    '/policy/global-settings/suspicious-object-settings': t(
      'policy.globalSettings.settings.suspiciousObject'
    ),
    '/policy/global-settings/time-of-click-protection-settings': t(
      'policy.globalSettings.settings.timeOfClickProtection'
    ),
    '/policy/global-settings/attachment-password-guessing': t(
      'policy.globalSettings.settings.attachmentPassword'
    ),
    '/policy/global-settings/conditional-access-policies-for-risky-users': t(
      'policy.globalSettings.settings.conditionalAccess'
    ),
    '/policy/global-settings/microsoft-licensing-model-settings-for-teams-chat':
      t('policy.globalSettings.settings.microsoftLicensingModelForTeams'),
    '/policy/global-settings/inline-protection-settings-for-exchange-online': t(
      'policy.globalSettings.settings.inlineProtectionForExchangeOnline'
    ),
    '/policy/global-settings/inline-protection-settings-for-gmail': t(
      'policy.globalSettings.settings.inlineProtectionForGmail'
    ),
    '/policy/global-settings/exchange-online-api-protection-settings': t(
      'policy.globalSettings.settings.exchangeOnlineApiProtection'
    ),
    [CorrelatedTemplateUrl.rules]: t(
      'policy.globalSettings.correlatedRules.ruleLists'
    ),
    [CorrelatedTemplateUrl.expressions]: t(
      'policy.globalSettings.correlatedRules.ruleLists'
    ),
    '/administrator/organization': t('side.group.administrator.orgManagement'),
    '/administrator/service-account': t(
      'side.group.administrator.serviceAccount'
    ),
    '/administrator/user-management': t('side.group.administrator.role'),
    '/administrator/license': t('side.group.administrator.licenseInformation'),
    '/administrator/single-sign-on': t(
      'side.group.administrator.singleSignOnSettings'
    ),
    '/administrator/api-token': t('side.group.administrator.apiToken'),
    '/administrator/euq': t('side.group.administrator.addInManagement'),
    '/policy/global-settings/synchronized-user-lists': t(
      'policy.globalSettings.userDefined.pocUserManagement'
    ),
  };

  const mainActionRouterNameMap: { [key: string]: string } = {
    '/policy/data-loss-prevention/add-policy/:service': t('side.group.policy'),
    '/policy/advanced-threat-protection/add-policy/:service':
      t('side.group.policy'),
  };

  const actionPolicySubRouterNameMap: { [key: string]: string } = {
    '/policy/advanced-threat-protection/add-policy/:service':
      'side.label.addATPPolicy',
    '/policy/data-loss-prevention/add-policy/:service':
      'side.label.addDLPPolicy',
  };

  const loadRouterName = () => {
    if (matches) {
      let firstTag = '';
      let secondTag = '';
      const pathnameBase = matches[0].route.path;
      const pathname = matches[0].pathname;
      if (mainRouterNameMap[pathnameBase]) {
        firstTag = mainRouterNameMap[pathnameBase];
        for (const key in policySubRouterNameMap) {
          if (pathname === key) {
            secondTag = policySubRouterNameMap[key];
          }
        }
      }
      if (mainActionRouterNameMap[pathnameBase]) {
        firstTag = mainActionRouterNameMap[pathnameBase];
        for (const key in actionPolicySubRouterNameMap) {
          if (pathnameBase === key) {
            const service = matches[0].params.service;
            if (service) {
              const serviceName = [
                'exchangeInlineInbound',
                'exchangeInlineOutbound',
                'gmailInlineInbound',
                'gmailInlineOutbound',
              ].includes(service)
                ? t(`common.sideTitleService.${service}`)
                : t(`common.service.${service}`);
              secondTag = t(actionPolicySubRouterNameMap[key], {
                service: serviceName,
              });
            }
          }
        }
      }

      console.log('parent', firstTag, secondTag);
      if (!firstTag || !secondTag) {
        if (isInUIC()) {
          if (['/welcome'].includes(matches[0].route.path)) {
            return [
              {
                breadCrumb: t('common.nativeApp.productName'),
                router: '',
              },
            ];
          } else {
            return [
              {
                breadCrumb: t('common.nativeApp.productName'),
                router: '',
              },
              {
                breadCrumb: t(matches[0].route.name),
                router: ``,
              },
            ];
          }
        }
        return [
          {
            breadCrumb: t(matches[0].route.name),
            router: matches[0].route.path,
          },
        ];
      }
      if (isInUIC()) {
        return [
          {
            breadCrumb: t('common.nativeApp.productName'),
            router: '',
          },
          {
            breadCrumb: firstTag,
            router: `/app/email-and-collaboration/${
              matches[0].route.path.split('/')[1]
            }?t=${new Date().getTime()}`,
          },
          {
            breadCrumb: secondTag,
            router: '',
          },
        ];
      }
      return [
        { breadCrumb: firstTag, router: '' },
        { breadCrumb: secondTag, router: '' },
      ];
    }
    return [{ breadCrumb: '', router: '' }];
  };

  return loadRouterName();
}
